<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-radio`]" width="1em" height="1em" v-bind="$attrs"><rect x="2.714" y="4.26" width="6" height="6" rx="3" stroke="#165DFF" stroke-width="1.66" stroke-linejoin="round"/><path d="M11.9363 5.22894H21.2845" stroke="#00BBD8" stroke-width="1.66" stroke-linecap="round" stroke-linejoin="round"/><rect x="2.714" y="13.739" width="6" height="6" rx="3" stroke="#00BBD8" stroke-width="1.66" stroke-linejoin="round"/><path d="M11.9363 9.29095H17.25" stroke="#00BBD8" stroke-width="1.66" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.9363 14.7082H21.2845M11.9363 18.7703H17.25" stroke="#165DFF" stroke-width="1.66" stroke-linecap="round" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconColorRadio',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
